import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
    Bar,
    BarChart,
    CartesianGrid, Legend,
    ResponsiveContainer, Tooltip,
    XAxis,
    YAxis
} from "recharts";
import AppContext from '../../AppContext'
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import QualityRecords from "./QualityRecords";
import SwipeableViews from 'react-swipeable-views';
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { get } from 'lodash'


// http://colorbrewer2.org/?type=sequential&scheme=GnBu&n=6
const styles = theme => ({
    card: {
        display: "flex",
        flexDirection: "column"
    },
    cardContent: {
        flexGrow: 1
    },
    stepper: {
        flexGrow: 1,
        background: "#fff"
    },
});


@withStyles(styles)
class QualityPanel extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {
        activeStep: 0,
        handleStep: (event, step) => this.setState({activeStep: step}),
        handleBack: () => this.setState((prevState, props) => {
            return {activeStep: prevState.activeStep - 1}
        }),
        handleNext: () => this.setState((prevState, props) => {
            return {activeStep: prevState.activeStep + 1}
        }),
    };

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <AppContext.Consumer>
                    {(context) => (
                        <Card
                            className={classes.paper}
                        >
                            <CardContent>
                                <Typography
                                    variant="h3"
                                    align="center"
                                    gutterBottom>
                                    Quality checks
                                </Typography>
                                <ResponsiveContainer
                                    width="100%"
                                    height={450}
                                    >
                                    {get(context, `state.data.iterations.${context.state.iteration_id}.qual_report.length`) === 0 ?
                                        <Typography>
                                            Quality checks are available only
                                            for
                                            iteration 8 and refine
                                            iteration</Typography>
                                        :
                                        <React.Fragment>
                                            <SwipeableViews
                                            index={this.state.activeStep}
                                            onChangeIndex={this.state.handleStep}
                                        >
                                            {context.state.data.iterations[context.state.iteration_id].qual_report.map((qual_report, index) => (
                                                <div key={qual_report.tool}>
                                                    <div>
                                                        <Typography
                                                            gutterBottom
                                                            variant="h5"
                                                        >
                                                            {qual_report.tool}
                                                        </Typography>
                                                    </div>
                                                    <QualityRecords
                                                        report={qual_report}/>
                                                </div>

                                            ))}
                                        </SwipeableViews>
                                            <MobileStepper
                                                variant="dots"
                                                steps={context.state.data.iterations[context.state.iteration_id].qual_report.length}
                                                position="static"
                                                activeStep={this.state.activeStep}
                                                className={classes.stepper}
                                                nextButton={
                                                    <Button size="small"
                                                            onClick={this.state.handleNext}
                                                            disabled={this.state.activeStep === context.state.data.iterations[context.state.iteration_id].qual_report.length - 1}>
                                                        Next
                                                        <KeyboardArrowRight/>
                                                    </Button>
                                                }
                                                backButton={
                                                    <Button size="small"
                                                            onClick={this.state.handleBack}
                                                            disabled={this.state.activeStep === 0}>
                                                        <KeyboardArrowLeft/>
                                                        Back
                                                    </Button>
                                                }
                                            />
                                        </React.Fragment>
                                    }
                                </ResponsiveContainer>
                            </CardContent>
                        </Card>
                    )}
                </AppContext.Consumer>
            </React.Fragment>
        );
    }
}

export default QualityPanel;